function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export default ({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8601 12.13C18.5301 12.6 17.6401 13.51 17.1601 16.86C17.1301 17.05 16.8701 17.05 16.8401 16.86C16.3701 13.51 15.4701 12.63 12.1401 12.14C11.9501 12.11 11.9501 11.84 12.1401 11.82C15.4501 11.35 16.3501 10.45 16.8301 7.15C16.8601 6.95 17.1401 6.95 17.1701 7.15C17.6501 10.45 18.5401 11.33 21.8601 11.81C22.0501 11.84 22.0501 12.11 21.8601 12.13Z",
  fill: fill || 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8601 8.13C8.53006 8.6 7.64006 9.51 7.16006 12.86C7.13006 13.05 6.87006 13.05 6.84006 12.86C6.37006 9.51 5.47006 8.63 2.14006 8.14C1.95006 8.11 1.95006 7.84 2.14006 7.82C5.45006 7.35 6.35006 6.45 6.83006 3.15C6.86006 2.95 7.14006 2.95 7.17006 3.15C7.65006 6.45 8.54006 7.33 11.8601 7.81C12.0501 7.84 12.0501 8.11 11.8601 8.13Z",
  fill: fill || 'currentColor'
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9201 18.08C10.9201 18.36 10.3901 18.91 10.1001 20.92C10.0801 21.03 9.92006 21.03 9.91006 20.92C9.63006 18.91 9.09006 18.38 7.09006 18.09C6.98006 18.07 6.98006 17.91 7.09006 17.9C9.08006 17.62 9.61006 17.08 9.90006 15.1C9.92006 14.98 10.0801 14.98 10.1001 15.1C10.3901 17.08 10.9201 17.61 12.9201 17.9C13.0301 17.92 13.0301 18.08 12.9201 18.09V18.08Z",
  fill: fill || 'currentColor'
}));
//# sourceMappingURL=EnhanceAI.js.map